import {
  createFileRoute,
  useLoaderData,
} from "@tanstack/react-router";
import { getCmsPageContent } from "~/lib/server-functions/get-cms-page-content";
import { getBaseUrl } from "~/lib/utils";
import { withLocale } from "~/lib/utils/with-locale";
import { seo } from "~/utils/seo";
import { LoginLayout } from "~/routes/_login/route";
import { SignUpPageContent } from "~/routes/_login/sign-up";

export const Route = createFileRoute("/__main/$locale/sign-up")({
  component: function LocaleSignUp() {
    const { cmsContent } = useLoaderData({
      from: "/__main/$locale/sign-up",
    });
    return (
      <LoginLayout>
        <SignUpPageContent cmsContent={cmsContent} />
      </LoginLayout>
    );
  },
  loader: async () => {
    let cmsContent: Awaited<ReturnType<typeof getCmsPageContent>>["content"] =
      [];
    let pageTitle: string | null = null;
    try {
      const result = await getCmsPageContent({ data: { slug: "/signup" } });
      if (result.content?.length) cmsContent = result.content;
      pageTitle = result.pageTitle ?? null;
    } catch {
      // No CMS content for this slug
    }
    return { cmsContent, pageTitle };
  },
  head: ({ loaderData, params }) => {
    const canonicalPath = withLocale("/sign-up", params.locale);
    const canonicalUrl = `${getBaseUrl()}${canonicalPath}`;
    const cmsTitle = loaderData?.pageTitle?.trim() || "";
    const title = cmsTitle
      ? `${cmsTitle} | Locationguide24`
      : "Registrieren | Locationguide24";

    return {
      meta: [
        ...seo({
          title,
          url: canonicalUrl,
          siteName: "Locationguide24",
          locale: "de_DE",
        }),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
